// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__3dX9F","row":"Node_row__1U_i6","label":"Node_label__fTHt1","footer":"Node_footer__2FlAl"};